import {SnackbarProvider} from "notistack";
import React from 'react';
import ReactDOM from 'react-dom';
import {App} from "./components/App";
//import {Auth} from "./components/Auth";
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import awsExports from './components/Auth/aws-exports';

// Configure Amplify in index file or root file
Amplify.configure({
  Auth: {
        region: awsExports.REGION,
        userPoolId: awsExports.USER_POOL_ID,
        userPoolWebClientId: awsExports.USER_POOL_APP_CLIENT_ID,
    }
})

ReactDOM.render(
  <React.StrictMode>
    <SnackbarProvider maxSnack={3} anchorOrigin={{
      horizontal: "center",
      vertical: "bottom"
    }}>

      <App/>

    </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById(process.env.REACT_APP_ROOT_ID || "root"),
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
